<template>
  <div class="app-container">
    <div class="userContent">
      <div class="userList userCharact flex alignCenter">
        <div>角色：</div>
        <div>{{ perDetails.role }}</div>
      </div>
      <div class="userList flex alignCenter mt20">
        <div>手机：</div>
        <div>{{ handleNum(iphoneNum) }}</div>
        <a @click="dialog">更改手机</a>
      </div>
      <div class="userList flex alignCenter mt20">
        <div>密码：</div>
        <div>***********</div>
        <a @click="passDialog">修改密码</a>
      </div>
    </div>
    <div class="el-message-box__wrapper" v-if="dialogIsShow">
      <div class="el-message-box" :class="dialogIsShow ? 'upDown' : ''">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>更改手机</span>
          </div>
          <button @click="hideAll" type="button" class="el-message-box__headerbtn">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content" v-if="step1">
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">当前手机：</div>
            <div class="iphoneNum">
              {{ handleNum(iphoneNum) }}
            </div>
          </div>
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">新手机：</div>
            <div class="iphoneNum">
              <input
                v-model="iphoneInput"
                :class="iphoneIsTrue ? 'borderRed' : ''"
                class="phoneNumInput"
                @blur="isPoneAvailable(iphoneInput)"
                type="text"
                name="phone"
              />
            </div>
          </div>
          <p class="verfly" v-show="iphoneIsTrue">请输入正确的手机号</p>
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">验证码：</div>
            <div class="iphoneNum">
              <input ref="yzmNum" class="yzm" type="text" name="yzm" placeholder="输入验证码" />
            </div>
            <button :class="!canClick || iphoneIsTrue ? 'disabled' : ''" class="yzmBtn ml10" @click="countDown()">
              {{ content }}
            </button>
          </div>
          <p v-if="phoneCode" class="verfly hide">验证码错误</p>
          <div class="dialogBtn mt40 tr">
            <button type="button" class="ag-model-btn gray fts" @click="hideAll">取消</button>
            <button type="button" class="ag-model-btn blue fts ml5" @click="toStep2">提交</button>
          </div>
        </div>
        <div class="el-message-box__content" v-if="step2">
          <div class="surrce">
            <img
              :class="'upDown'"
              src="data:image/png;base64,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"
            />
            <p :class="'upDown'" class="mt10">手机更换成功</p>
          </div>

          <div class="dialogBtn mt40 tc">
            <button type="button" class="ag-model-btn blue fts" @click="resIphone">确定</button>
          </div>
        </div>
      </div>
    </div>

    <div class="el-message-box__wrapper" v-if="resPassWord">
      <div class="el-message-box" :class="resPassWord ? 'upDown' : ''">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>修改密码</span>
          </div>
          <button @click="hideAll" type="button" class="el-message-box__headerbtn">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">原密码：</div>
            <div class="iphoneNum">
              <input
                ref="oldPass"
                :class="passIsShow ? 'borderRed' : ''"
                @blur="oldPasw($event)"
                class="phoneNumInput"
                type="password"
                name="pass"
              />
            </div>
          </div>
          <p class="verfly" v-show="passIsShow">原密码错误</p>
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">新密码：</div>
            <div class="iphoneNum">
              <input
                @blur="newPassW"
                onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                ref="newPass"
                :class="newPass ? 'borderRed' : ''"
                class="phoneNumInput"
                type="password"
                name="pass"
              />
            </div>
          </div>
          <p class="verfly" v-show="newPass">密码不能少于8位</p>
          <div class="flex alignCenter item mt20">
            <div class="itemTitle">确认密码：</div>
            <div class="iphoneNum">
              <input
                @blur="newPassWsure"
                onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                ref="newPassSure"
                :class="newPassSure ? 'borderRed' : ''"
                class="phoneNumInput"
                type="password"
                name="pass"
              />
            </div>
          </div>
          <p class="verfly" v-show="newPassSure">两次输入的密码不一致</p>
          <div class="dialogBtn mt40 tr">
            <button type="button" class="ag-model-btn gray fts" @click="hideAll">取消</button>
            <button @click="storgePassw" type="button" class="ag-model-btn blue fts ml5">保存</button>
          </div>
        </div>
      </div>
    </div>
    <div class="dialogMask" v-show="maskPop" :class="maskPop ? 'dialogMaskAnimation' : ''"></div>
  </div>
</template>

<script>
import { httpUrl, storeHttp, storeHttpV2 } from 'src/utils/common'
import { vm } from 'src/utils/public'

export default {
  data() {
    return {
      maskPop: false,
      dialogIsShow: false,
      iphoneNum: '13366671527',
      iphoneInput: '',
      step1: true,
      step2: false,
      resPassWord: false,
      iphoneIsTrue: false,
      countdown: 60,
      canClick: true,
      content: '发送验证码',
      totalTime: 60,
      perDetails: '',
      passIsShow: false,
      newPass: false,
      newPassSure: false,
      phoneCode: false,
    }
  },
  methods: {
    isPoneAvailable(str) {
      let that = this
      if (!that.iphoneInput) {
        that.iphoneIsTrue = false
        return
      }
      var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!myreg.test(str)) {
        that.iphoneIsTrue = true
        return false
      } else {
        that.iphoneIsTrue = false
        return true
      }
    },
    countDown() {
      if (this.iphoneInput != '' && this.iphoneIsTrue == false) {
        if (!this.canClick) return
        let url = httpUrl + '/api/current/isAvailableMobile'
        let data = {
          mobile: this.iphoneInput,
        }
        vm.myAPI(data, url).then((res) => {
          if (status == 0) {
            if (res.data) {
              this.canClick = false
              this.content = `重新发送(${this.totalTime}s)`
              this.iphoneIsTrue = false
              let sendData = {
                mobile: this.iphoneInput,
              }
              let sUrl = httpUrl + '/api/current/sendMobileCode'
              vm.myAPI(sendData, sUrl).then((res) => {
                if (status == 0) {
                  if (res.data) {
                    this.phoneCode = false
                  } else {
                    this.phoneCode = true
                  }
                }
              })
              let clock = window.setInterval(() => {
                this.totalTime--
                this.content = `重新发送(${this.totalTime}s)`
                if (this.totalTime < 0) {
                  window.clearInterval(clock)
                  this.content = '发送验证码'
                  this.totalTime = 60
                  this.canClick = true
                }
              }, 1000)
            } else {
              this.$message('手机号已经被使用!')
            }
          }
        })
      }
    },
    oldPasw(e) {
      let even = window.event || e
      if (!even.target.value) {
        this.passIsShow = false
        return
      }
      let data = {
        password: even.target.value,
      }
      let url = httpUrl + '/api/current/isRightPwd'
      vm.myAPI(data, url).then((res) => {
        if (status == 0) {
          if (res.data) {
            this.passIsShow = false
          } else {
            this.passIsShow = true
          }
        }
      })
    },
    newPassW() {
      if (!this.$refs.newPass.value) {
        this.newPass = false
        return
      }
      if (this.$refs.newPass.value.length < 8) {
        this.newPass = true
      } else {
        this.newPass = false
      }
    },
    newPassWsure() {
      if (this.$refs.newPass.value == this.$refs.newPassSure.value) {
        this.newPassSure = false
      } else {
        this.newPassSure = true
      }
    },
    storgePassw() {
      let that = this
      this.newPassW()
      this.newPassWsure()
      let url = httpUrl + '/api/current/changePwd'
      let data = {
        password: that.$refs.oldPass.value,
        newpwd: that.$refs.newPass.value,
      }
      if (
        this.passIsShow == false &&
        this.$refs.newPass.value.length >= 8 &&
        this.$refs.newPass.value == this.$refs.newPassSure.value
      ) {
        vm.myAPI(data, url).then((res) => {
          if (res.status == 0) {
            if (res.data == true) {
              //that.$message('密码修改成功,请重新登陆!');
              this.hideAll()
              setTimeout(() => {
                localStorage.removeItem('user')
                location.href = '/login/'
              }, 2000)
            }
          } else {
            //that.$message(res.msg);
          }
        })
      } else {
        //that.$message('请完善信息!');
      }
    },
    toStep2() {
      if (!this.iphoneInput || !this.$refs.yzmNum.value) {
        if (!this.iphoneInput) {
          this.iphoneIsTrue = true
        }
        return
      }
      let url = httpUrl + '/api/current/changeMobile'
      let data = {
        mobile: this.iphoneInput,
        smscode: this.$refs.yzmNum.value,
      }
      vm.myAPI(data, url).then((res) => {
        if (res.status == 0) {
          if (res.data) {
            this.step1 = false
            this.step2 = true
          } else {
            that.$message(res.msg)
          }
        }
      })
    },
    resIphone() {
      this.getPerDetails()
      this.step1 = true
      this.step2 = false
      this.hideAll()
    },
    dialog() {
      this.iphoneIsTrue = false
      this.iphoneInput = ''
      this.maskPop = true
      this.dialogIsShow = true
    },
    passDialog() {
      this.passIsShow = false
      this.newPass = false
      this.newPassSure = false
      this.maskPop = true
      this.resPassWord = true
    },
    hideAll() {
      this.maskPop = false
      this.dialogIsShow = false
      this.resPassWord = false
    },
    handleNum(num) {
      let val = num.toString().replace(/[^\d]/g, '')
      let arr = val.split('')
      let str = ''
      arr.forEach(function (val, ind) {
        if (ind === 3 || ind === 7) {
          str += ' '
        }
        str += val
      })
      return str
    },
    getPerDetails() {
      let url = httpUrl + '/api/current/info'
      let data = ''
      vm.myAPI(data, url).then((res) => {
        if (status == 0) {
          this.perDetails = res.data
          this.iphoneNum = res.data.mobile
        }
      })
    },
  },
  watch: {},
  computed: {},
  mounted() {
    this.getPerDetails()
  },
}
</script>

<style lang="less" scoped>
.userTitle {
  font-size: 14px;
  color: #4d4d4d;
}
.userTitle a {
  color: #5c76cc;
}
.session1 {
  height: 70px;
  padding: 0px 20px 0 20px;
  margin: 0 -20px;
  align-items: center;
}
.userContent {
  padding: 40px 0 0 100px;
}
.userList div:nth-child(1) {
  font-size: 14px;
  color: #333;
  text-align: right;
  font-weight: bold;
}
.userList div:nth-child(2) {
  font-size: 12px;
  color: #333;
  width: 95px;
  margin-left: 20px;
}
.userCharact div:nth-child(2) {
  width: 150px;
}
.userList a {
  font-size: 12px;
  color: #5c76cc;
  cursor: pointer;
}

.el-message-box__header {
  border-bottom: 1px solid #e6e6e6;
}
.el-message-box__wrapper {
  z-index: 101;
}
.el-message-box {
  width: 400px;
}
.el-message-box__content {
  padding-bottom: 0;
}
.dialogMask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 100;
}
.dialogMaskAnimation {
  -webkit-animation: animationShow 0.3s;
  -moz-animation: animationShow 0.3s;
  -ms-animation: animationShow 0.3s;
  animation: animationShow 0.3s;
}
.upDown {
  -webkit-animation: animationDown 0.3s;
  -moz-animation: animationDown 0.3s;
  -ms-animation: animationDown 0.3s;
  animation: animationDown 0.3s;
}

@keyframes animationDown {
  from {
    margin-top: -30px;
  }
  to {
    margin-top: 0;
  }
}
@keyframes animationShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}
.ag-model-btn {
  font-family: 'Microsoft Yahei', Helvetica, sans-serif;
  min-width: 63px;
  height: 30px;
  padding: 0 10px;
  cursor: pointer;
  vertical-align: middle;
  border-radius: 2px;
}
.ag-model-btn.blue {
  color: #fff;
  border: 1px solid #5c76cc;
  background-color: #5c76cc;
}
.fts {
  font-size: 12px;
}
.ag-model-btn.gray {
  color: #333;
  background-color: #f4f5f7;
  border: 1px solid #d2d2d2;
}
.tr {
  text-align: right;
}
.tc {
  text-align: center;
}
.itemTitle {
  width: 120px;
  text-align: right;
  font-size: 14px;
  color: #333;
}
.iphoneNum,
.yzmBtn,
.phoneNumInput,
.yzm {
  font-size: 12px;
  color: #333;
}
.phoneNumInput,
.yzm {
  height: 28px;
  line-height: 28px;
  width: 188px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding-left: 10px;
}
.yzm {
  width: 88px;
}
.yzmBtn {
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: #5c76cc;
  border-radius: 2px;
  cursor: pointer;
}
.verfly {
  font-size: 12px;
  color: #ff2600;
  padding-left: 120px;
  margin-top: 6px;
}
.surrce {
  text-align: center;
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.borderRed {
  border: 1px solid red;
}
.disabled {
  background: #f4f5f7;
  border-radius: 2px;
  font-size: 12px;
  color: #999999;
  cursor: not-allowed; // 鼠标变化
}
</style>